import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetOffer } from 'slices/offerSlice';
import error from '../../assets/error-request.svg';
import invoice from '../../assets/invoice.svg';

const ErrorContainerOffer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { detail } = useSelector((state) => state.detail);
  const { message } = useSelector((state) => state.offer.offer);
  const tryAgain = () => {
    navigate(-1);
    dispatch(resetOffer());
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile-error')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  return (
    <>
      <div className="bg-alabaster pt-5 p-sm-3 pb-30 d-block d-sm-none sticky-resumen-mobile-error">
        <div className="wrap">
          <button
            type="button"
            className="header bg-alabaster d-flex justify-content-between btn-link text-left">
            <div className="title opacity-70 ml-2 d-flex">
              <img src={invoice} alt="invoice-img" />
              <h4 className="mt-15 text-tangaroa ml-3">Confirmación</h4>
            </div>
            <div className="icon-title font-weight-bold text-tangaroa">
              <i className="fas fa-plus" />
            </div>
          </button>
        </div>
      </div>
      <Container className="bg-white">

        <Row className="pb-60 py-sm-60">
          <Col lg={9} className="text-center text-tangaroa">
            <h2 className="mb-15 text-tangaroa mt-60 mt-sm-0">¡Lo sentimos!</h2>
            {message === 'La oferta no es multipo de los incrementos.' ? (
              <h3 className="text-tangaroa">La oferta no es multipo de los incrementos.</h3>
            ) : (
              <>
                <h3 className="text-tangaroa">Ha ocurrido un error al momento de procesar tu solicitud.</h3>
                <h3 className="text-tangaroa mb-45">Estamos trabajando en ello para resolverlo.</h3>
              </>
            )}

            <img src={error} alt="error-img" />
            <h4 className="mb-30 text-tangaroa f-600">Haz clic en el botón para intentarlo de nuevo.</h4>
            <button type="button" className="btn btn-primary mb-15" id="sbs-dsb-dgr-btn-mor" onClick={tryAgain}>
              Reintentar
            </button>
          </Col>
          <Col lg={3} className="opacity-70">
            <div className="bg-alabaster p-3 br-1 d-none d-sm-block">
              <img src={invoice} alt="invoice-img" />
              <h4 className="mt-15 text-tangaroa">Confirmación</h4>
              <Row className="text-dark-blue ft-12">
                <Col lg={10}>
                  Puntos ofertados
                </Col>
                <Col lg={2}>
                  0
                </Col>
              </Row>
              <h4 className="mt-15 text-tangaroa">Tu Subasta Rewards</h4>
              <h5>{detail.title}</h5>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ErrorContainerOffer;
